import { render } from "./Header.vue?vue&type=template&id=59c8c968&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=59c8c968&lang=scss&scoped=true"

import exportComponent from "/var/www/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c8c968"]])

export default __exports__